import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { Component, OnInit, Input } from "@angular/core";
import { BUTTON_WHEEL, BUTTON_WHEEL_GREY } from '../../services/loader.library';

@Component({
    selector: 'loader',
    imports: [MatIconModule],
    template: `<mat-icon title="Loading Wheel" [svgIcon]="icon"></mat-icon>`,
    styles: [`:host {display:block;} .mat-icon { height:100%; width:100%; }`],
    standalone: true,
})
export class LoaderComponent implements OnInit {

  @Input() icon;
  @Input() title;
  icons = {
    BUTTON_WHEEL:BUTTON_WHEEL,
    BUTTON_WHEEL_GREY:BUTTON_WHEEL_GREY
  }
  constructor(private iconReg: MatIconRegistry, private sanitizer: DomSanitizer){ }
  ngOnInit(){
    if (this.icons[this.icon.toUpperCase()]) this.iconReg.addSvgIconLiteral(this.icon, this.sanitizer.bypassSecurityTrustHtml(this.icons[this.icon.toUpperCase() ]))
    else console.error('loader not found in icons ',this.icon, this.icons)
  }
}
